// Analytics: self-hosted Umami (fase 4, GDPR). Replaced Mixpanel, and nothing leaves Breefer. Umami sets no cookies and stores nothing in the
// browser; the data stays on Breefer's own server. Event names are kept, but only non-personal properties are sent
// (no ids, e-mails, phone numbers or free text), and users are never identified.
// The script is loaded by the app when the Umami address and website id are configured (see index/layout).

declare global {
  interface Window {
    umami?: { track: (event: string, data?: Record<string, string | number>) => void };
  }
}

// Properties that describe the page or the product, never the person
const SAFE_PROPERTIES = ["current_page", "page", "game_name", "number_of_qustions", "plan", "plan_name", "step", "language"];

const safeProperties = (props: any) =>
  Object.fromEntries(
    Object.entries(props || {})
      .filter(([key, value]) => SAFE_PROPERTIES.includes(key) && (typeof value === "number" || (typeof value === "string" && value.length <= 100)))
      .map(([key, value]) => [key, value as string | number])
  );

const track = (name: string, props?: any) => {
  try {
    if (typeof window !== "undefined") window.umami?.track(name, safeProperties(props));
  } catch {
    // analytics must never break the app
  }
};

const actions = {
  // No identification of users: these are kept so existing calls keep working
  identify: (_id: string) => undefined,
  alias: (_id: string) => undefined,
  reset: () => undefined,
  people: {
    set: (_props: any) => undefined,
  },
  track,
  // Umami records page views itself
  trackpageView: (_pageName: string) => undefined,
};

export default actions;
